import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, Pagination, formatDate } from '../../components/shared';
import api from '../../services/api';
import toast from 'react-hot-toast';

const hoje = () => new Date().toISOString().slice(0, 10);
const diasAtras = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);

export default function MasterLogsAcesso() {
  const [logs, setLogs]       = useState([]);
  const [total, setTotal]     = useState(0);
  const [page, setPage]       = useState(1);
  const [loading, setLoad]    = useState(true);
  const [busca, setBusca]     = useState('');
  const [dataInicio, setDataInicio] = useState(diasAtras(7));
  const [dataFim, setDataFim]       = useState(hoje());

  useEffect(() => {
    setLoad(true);
    api.get('/logs-acesso', {
      params: { page, limit: 20, data_inicio: dataInicio, data_fim: dataFim, busca: busca || undefined },
    })
      .then(r => { setLogs(r.data.dados); setTotal(r.data.total); })
      .catch(() => toast.error('Erro ao carregar logs de acesso'))
      .finally(() => setLoad(false));
  }, [page, dataInicio, dataFim, busca]);

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="master" />
      <div className="main-content">
        <div className="topbar"><h1>Logs de Acesso</h1></div>
        <div className="page-content">
          <div className="table-card">
            <div className="table-header" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label" style={{ fontSize: '.75rem' }}>De</label>
                <input
                  type="date"
                  className="form-control"
                  value={dataInicio}
                  onChange={e => { setDataInicio(e.target.value); setPage(1); }}
                  style={{ width: 160 }}
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label className="form-label" style={{ fontSize: '.75rem' }}>Até</label>
                <input
                  type="date"
                  className="form-control"
                  value={dataFim}
                  onChange={e => { setDataFim(e.target.value); setPage(1); }}
                  style={{ width: 160 }}
                />
              </div>
              <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 200 }}>
                <label className="form-label" style={{ fontSize: '.75rem' }}>Buscar</label>
                <input
                  className="form-control"
                  placeholder="Nome ou e-mail..."
                  value={busca}
                  onChange={e => { setBusca(e.target.value); setPage(1); }}
                />
              </div>
              <span style={{ fontSize: '.8rem', color: 'var(--text-muted)', alignSelf: 'flex-end', paddingBottom: 8 }}>
                {total} registro(s)
              </span>
            </div>

            {loading ? <div className="loading-center"><div className="spinner" /></div> : (
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Usuário</th>
                      <th>E-mail</th>
                      <th>Perfil</th>
                      <th>Resultado</th>
                      <th>IP</th>
                      <th>Data/Hora</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map(l => (
                      <tr key={l.id}>
                        <td style={{ fontWeight: 600 }}>{l.usuario_nome || '—'}</td>
                        <td style={{ color: 'var(--text-muted)' }}>{l.email}</td>
                        <td>
                          {l.usuario_perfil ? (
                            <span className={`badge ${l.usuario_perfil === 'master' ? 'badge-orange' : 'badge-info'}`}>
                              {l.usuario_perfil === 'master' ? 'Master' : 'Admin Empresa'}
                            </span>
                          ) : '—'}
                        </td>
                        <td>
                          <span className={`badge ${l.sucesso ? 'badge-success' : 'badge-danger'}`}>
                            {l.sucesso ? 'Sucesso' : (l.motivo === 'empresa_inativa' ? 'Empresa inativa' : 'Falha')}
                          </span>
                        </td>
                        <td style={{ fontSize: '.8rem' }}>{l.ip || '—'}</td>
                        <td style={{ fontSize: '.8rem' }}>{formatDate(l.data_hora)}</td>
                      </tr>
                    ))}
                    {!logs.length && (
                      <tr><td colSpan={6}>
                        <div className="empty-state">
                          <Icon name="clock" />
                          <h3>Nenhum log de acesso encontrado para o período</h3>
                        </div>
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <div className="table-footer">
              <span>Mostrando {logs.length} de {total}</span>
              <Pagination page={page} total={total} limit={20} onChange={setPage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
